import React from "react";
import {Avatar, Card, Col, Row, Typography} from "antd";
import {Link} from "react-router-dom";
import {
    PlusOutlined,
    QuestionCircleOutlined,
    UnorderedListOutlined,
    UserOutlined,
    WarningOutlined
} from "@ant-design/icons";
import {
    faBars,
    faChartScatter, faMap,
    faProjectDiagram,
    faScalpel,
    faTrashAlt,
    faUsers
} from "@fortawesome/pro-light-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import {MainPageCard} from "../components/MainPageCard";
import {tokens} from "../components/ui/tokens";
import {useGetOnceHttp} from "../hooks/inithttp.hook";
import moment from "moment";
import {useUser} from "../hooks/user.hook";

const NewsCard = ({news}) => {
    return <Card size={"small"} bordered={false} title={news.HEADLINE}
                 style={{marginBottom: 12, borderRadius: 12, boxShadow: tokens.shadow}}
                 extra={<Link to={`/news/${news.CD}`}>Подробнее</Link>}>
        <Row>
        <Col span={4}>
            <Avatar
                icon={news.OPTVALUES == 1 ? <QuestionCircleOutlined /> : news.OPTVALUES == 2 ? <WarningOutlined />: <UnorderedListOutlined />}
                style={
                    news.OPTVALUES == 1 ?
                        { backgroundColor: '#2763ff' } :
                    news.OPTVALUES == 2 ? { color: '#f56a00', backgroundColor: '#fde3cf' }:
                { backgroundColor: '#87d068' }}
            />
        </Col>
        <Col span={20}>

            <Typography.Text>{news.DIGEST}</Typography.Text>
            <Typography.Paragraph type="secondary">Опубликовано: {moment.utc(news.BEGSDATE).format('DD-MM-YYYY')}</Typography.Paragraph>
        </Col>
        </Row>
    </Card>
}

const NewsBar = () => {
    const [News] = useGetOnceHttp({url: '/api/news/all', def: []})
    return <>
        <Typography.Title level={5} style={{fontWeight: 600, marginBottom: 12}}>Новости платформы</Typography.Title>
        <NewsCard news={{HEADLINE: "Вышли новые клинические рекомендации", OPTVALUSE: "1", DIGEST: "Вышли новые клинические рекомендации по Рак Молочной железы. Обновлённые модели уже доступны на платформе", BEGSDATE: '2021-11-28'}}></NewsCard>
        {
//            News && News.map((n) => <NewsCard news={n}></NewsCard>)
        }
    </>
}




const StartPage = () => {
    const height = 375
    return (<>
        <div style={{marginBottom: 16}}>
            <Typography.Title level={3} style={{margin: 0, fontWeight: 600}}>Модели</Typography.Title>
            <Typography.Text type={"secondary"}>
                Цифровые двойники потоков пациентов: заболеваемость, маршрут терапии и сценарии лечения
            </Typography.Text>
        </div>
        <Row gutter={[16, 16]} wrap>
        <Col xs={24} xl={18}>
        <Row gutter={[16, 16]}>
            <MainPageCard title={"Предмодели"} description={"Популяционная статистическая информация на основании данных открытых источников"} link={"/"} img={"card_06.jpg"} icon={faMap} height={400}/>

            { /*
                <MainPageCard title={"Регистр ЗНО (Канцер-регистр)"}
                              description={"Реистр пациентов со злокачественными новообразованиями"}
                              link={"/patients"} icon={faUsers} height={height} img={"card_01.jpg"}/>
                <MainPageCard title={"Регистр предраков"} description={"Реистр пациентов с предраковыми заболеваниями и пациентов группы повышенного онкологического риска"}
                link={"/patients?pre"} icon={faUsers} height={height} img={"card_02.jpg"}/>
                <MainPageCard title={"Регистр скрининга"} description={"Реистр пациентов прошедших скрининг (независимо от результата)"} icon={faUsers}
                height={height} img={"card_03.jpg"}/>
                <MainPageCard title={"Гематологический регистр"} description={"Реистр пациентов гематологическими и онко-гематологическими заболеваниями"}
                link={"/patients?pre"} icon={faUsers} height={height} img={"card_04.jpg"}/>
                <MainPageCard title={"Детский канцер-регистр"} description={"Регистр пациентов с ЗНО до 18 лет"}
                link={"/patients?pre"} icon={faUsers} height={height} img={"card_05.jpg"}/> */
            }
        <MainPageCard title={"РМП"} description={"Рак мочевого пузыря"}  company={'roche'}
                      link={"/models/rmp"} icon={faChartScatter} height={height} img={"card_07.jpg"}/>
        <MainPageCard title={"РПЖ"} description={"Рак предстательной железы"} company={'j'}
                      link={"/models/rpg"} icon={faChartScatter} height={height} img={"card_10.jpg"}/>
        <MainPageCard title={"РЛ"} description={"Рак лёгкого"} company={'roche'} //company={'j'}
                      link={"/models/rl"} icon={faChartScatter} height={height} img={"card_09.jpg"}/>
        <MainPageCard title={"ХЛЛ"} description={"Хронический лимфоцитарный лейкоз"}
                      link={"/models/hll"} icon={faChartScatter} height={height} img={"card_08.jpg"}/>
        <MainPageCard title={"ММ"} description={"Множественная миелома"} company={'j'}
                      link={"/models/mm"} icon={faChartScatter} height={height} img={"card_11.jpg"}/>
        <MainPageCard title={"РМЖ"} description={"Рак молочной железы, HER2+"} company={'roche'}
                      link={"/models/rmg"} icon={faChartScatter} height={height} img={"card_01.jpg"}/>
    </Row>
        </Col>
        <Col xs={24} xl={6}>
            <NewsBar/>
        </Col>
        </Row>
    </>)}

export default StartPage